import { useQuery } from '@tanstack/react-query';

import { StepExecution } from '@frontend/types/stepExecution';

import { agentExecutionsService } from '../services/agentExecutions';

export function useStepExecutionDetails(stepExecution: StepExecution | null, shouldPoll = false) {
  const executionUrl = stepExecution?.links?.execution;

  return useQuery({
    queryKey: ['stepExecutionDetails', stepExecution?.step_id, executionUrl],
    queryFn: () => {
      if (!executionUrl) throw new Error('executionUrl is required');
      return agentExecutionsService.getExecutionDetails(executionUrl);
    },
    enabled: !!executionUrl,
    staleTime: shouldPoll ? 0 : 1000 * 60,
    refetchInterval: shouldPoll ? 5000 : false,
    retry: 1,
  });
}
